// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.page-basic-info {}
.page-basic-info__new-button {
    background: var(--white-color);
    border-radius: 2px;
}


.page-basic-info__content {
    display: flex;
    flex-direction: column;
}
.page-basic-info__content__section {
    display: flex;
    justify-content: center;
}
.page-basic-info__content__label {
    display: flex;
    justify-content: center;
    min-height: var(--space-and-half);
    align-items: center;
}
.page-basic-info__content__content {
    min-height: var(--space-x2);
    max-width: var(--space-and-half);
    max-height: var(--space-and-half);
    display: flex;
    justify-content: space-evenly;
    align-items: center;
}

.page-basic-info__content__content img {
    width: 100%;
}
.page-basic-info__content__country {
    width: 20%;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.page-basic-info__content__city {
    width: 20%;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.page-basic-info__content__age {
    width: 20%;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.page-basic-info__content__website {
    justify-self: flex-start;
    width: 100%;
    display: flex;
    align-items: center;
}
.page-basic-info__content__website__caption {
    margin-left: var(--space-half);
    color: var(--basic-gray-color) !important;
} 
.page-basic-info__content__website__icon {
    display: flex;
    justify-content: center;
    align-items: center;
} `, "",{"version":3,"sources":["webpack://./src/app/pages/components/page-basic-info/PageBasicInfoComponent.style.css"],"names":[],"mappings":";AACA,kBAAkB;AAClB;IACI,8BAA8B;IAC9B,kBAAkB;AACtB;;;AAGA;IACI,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,iCAAiC;IACjC,mBAAmB;AACvB;AACA;IACI,2BAA2B;IAC3B,gCAAgC;IAChC,iCAAiC;IACjC,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;AACA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,wBAAwB;IACxB,WAAW;IACX,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,8BAA8B;IAC9B,yCAAyC;AAC7C;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB","sourcesContent":["\n.page-basic-info {}\n.page-basic-info__new-button {\n    background: var(--white-color);\n    border-radius: 2px;\n}\n\n\n.page-basic-info__content {\n    display: flex;\n    flex-direction: column;\n}\n.page-basic-info__content__section {\n    display: flex;\n    justify-content: center;\n}\n.page-basic-info__content__label {\n    display: flex;\n    justify-content: center;\n    min-height: var(--space-and-half);\n    align-items: center;\n}\n.page-basic-info__content__content {\n    min-height: var(--space-x2);\n    max-width: var(--space-and-half);\n    max-height: var(--space-and-half);\n    display: flex;\n    justify-content: space-evenly;\n    align-items: center;\n}\n\n.page-basic-info__content__content img {\n    width: 100%;\n}\n.page-basic-info__content__country {\n    width: 20%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n.page-basic-info__content__city {\n    width: 20%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n.page-basic-info__content__age {\n    width: 20%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n.page-basic-info__content__website {\n    justify-self: flex-start;\n    width: 100%;\n    display: flex;\n    align-items: center;\n}\n.page-basic-info__content__website__caption {\n    margin-left: var(--space-half);\n    color: var(--basic-gray-color) !important;\n} \n.page-basic-info__content__website__icon {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
